import { useGetAssetDataForStatus, useDeregisterAssetDriver } from '../../api/LogbookApi';
import { useEffect } from 'react';
import { driverActionErrorMessage } from '../other/ConfigBasic';
import { useTranslation } from 'react-i18next';

export default function AdminCheckAndLogoutDriver(props) {
    const { updateLogbookPrivateJourney, idAsset, isPrivatModusActive, setMessage, setSelected } = props;
    // network-only: the effect below decides what to do based on the *current* driver
    // state and then clears the selection. With the default cache-and-network policy a
    // cached result can fire the effect while the fresh fetch is still in flight, and
    // the setSelected([]) below then unmounts this component and aborts that request
    // (net::ERR_ABORTED). network-only keeps the check authoritative and lets the
    // request finish before the component is torn down.
    const vehicleData = useGetAssetDataForStatus(idAsset, setMessage, 'network-only');
    const { deregisterAssetDriver } = useDeregisterAssetDriver();
    const { t } = useTranslation();

    // Goes through the asset driver route rather than the logbook one. The logbook
    // route resolves the caller against logbook.idDrivers and 404s when they are not a
    // driver of it, so this flow only ever worked for an admin who happened to also be
    // a driver of the logbook they were administering. The asset route accepts the
    // registered driver *or* an admin, which is what this flow actually needs (IC-961).
    const logoutDriver = (successKey) => {
        deregisterAssetDriver({
            variables: { idAsset },
            onCompleted: () => {
                setMessage(t(successKey));
            },
            onError: (error) => {
                setMessage(driverActionErrorMessage(error, t));
            },
            refetchQueries: ['getAllLogbooks', 'getAssetDataForStatus'],
        });
    };

    const updateRegistration = (isPrivateSwitchDeaktivated, onlyUserLogout = false) => {
        if (onlyUserLogout) {
            logoutDriver('driverLogoutInfo');
        } else if (isPrivateSwitchDeaktivated) {
            logoutDriver('driverLogoutInfoExtension');
        }
    };

    const checkAndLogoutUser = () => {
        // Only a software registration can be logged out. A driver identified by
        // driver key is the current driver but has nothing for this flow to close, so
        // it is reported as "no driver registered" rather than a silent no-op.
        if (vehicleData?.currentDriver?.software?.active === true) {
            if (isPrivatModusActive) {
                updateLogbookPrivateJourney(false, updateRegistration);
            } else {
                updateRegistration(true, true);
            }
        } else {
            setMessage(t('noDriverRegistered'));
            setSelected([]);
        }
    };

    useEffect(() => {
        if (vehicleData?.currentDriver) {
            checkAndLogoutUser();
        }
        // eslint-disable-next-line
    }, [vehicleData?.currentDriver]);
}
